import React from "react"
import { Button } from "@/components/Primitives/Button"
import { useNavigate } from "react-router-dom"
import { Text } from "@/components/Primitives/Text"
import { useConfig } from "@/hooks/useConfig"
import { Card } from "@/components/Primitives"

export function NotFoundPage() {
  const navigate = useNavigate()
  const { t } = useConfig()

  return (
    <div className="flex items-center justify-center">
      <Card className="flex flex-col items-center justify-center min-h-[85vh] md:min-h-[80vh] md:w-fit md:px-10">
        <img
          src="/images/empty-box.png"
          alt=""
          className="w-40 h-40 mb-2"
          draggable={false}
        />
        <Text variant="h1" bold className="text-purple-200 text-[4rem]">
          404
        </Text>
        <Text variant="h3" bold className="text-center mb-6">
          {t("config_404_message")}
        </Text>
        <Button variant="tertiary" onClick={() => navigate("/")}>
          {t("config_404_button")}
        </Button>
      </Card>
    </div>
  )
}
